module.exports = __webpack_public_path__ + "static/media/flint.d588908c.svg";